<template>
  <div class="content-wrapper">
    <ContentHeader :title="id ? 'Редактирование наряда № ' + id : 'Создание наряда'" />
    <div class="content-body">
        <!--span>{{ id }} - {{ workorder }}<button @click="show_workorders" >sdfsa</button></span-->
      <!--card hideHeader hideReload 
        :busy="isWorkOrdersLoading || isCardsLoading || isFuelsLoading || isStations2Loading 
            || fuelsOptions.length == 0 || cardsOptions.length == 0 || stationsOptions.length == 0"-->
      <card hideHeader hideReload 
        :busy="isWorkOrdersLoading || isCardsLoading || isFuelsLoading || isStations2Loading">

        <template slot="block" v-if="workorder">
          <div id="workordereditform">
            <div class="row form-group">
                <label class="col-sm-2 control-label">Дата отгрузки</label>
                <div class="col-sm-10">                    
                    <datepicker
                        format="DD.MM.YYYY"
                        placeholder="Дата отрузки"
                        input-class="form-control bg-lighten-4"
                        style="width: 50%"
                        v-model="workorder.target_date"                        
                    ></datepicker>
                </div>
            </div>
            <div class="row form-group" :class="errors.stationErr ? 'workorder_from_error':''">
                <label class="col-sm-2 control-label">Объект</label>
                <div class="col-sm-10">
                    <!--input
                    type="text"
                    class="form-control"
                    :value="workorder.station_name"
                    v-if="getStations.length == 1 || getStations.length == 2"
                    disabled
                    />
                    <select 
                        class="form-control"
                        v-model="workorder.station_id">
                        <option v-for="s in getStations" :value="s.id" :key="s.id">{{ s.name }}</option>
                    </select--> 

                    <v-select 
                        style="padding: 0 0 0.5rem 0"
                        :options="stationsOptions" 
                        :reduce="(option) => option.id"
                        :clearable="false"
                        :searchable="stationsOptions.length>5"
                        v-model="workorder.station_id"
                        :disabled="stationsOptions.length == 1 && workorder.station_id==stationsOptions[0].id"

                        _v-if="stationsOptions.length>0"
                    >
                    <div slot="no-options">Соответствий не найдено!</div>
                    </v-select>    
                </div>
            </div>
            <div class="row form-group" :class="errors.cardErr ? 'workorder_from_error':''">
                <label class="col-sm-2 control-label">Карта / водитель </label>
                <div class="col-sm-10">
                    <!--select 
                        class="form-control"
                        v-model="workorder.card_id">
                        <option v-for="card in getCards()" :value="card.id" :key="card.id">{{ card.id }} / {{ card.holder_name }}</option>
                    </select-->
                    <v-select 
                        style="padding: 0 0 0.5rem 0"
                        :options="cardsOptions"
                        :reduce="(option) => option.id"
                        :clearable="false"                        
                        v-model="workorder.card_id"

                        _v-if="cardsOptions.length>0"
                    >
                    <div slot="no-options">Соответствий не найдено!</div>
                    </v-select>
                </div>
            </div>
            <div class="row form-group">
                <label class="col-sm-2 control-label">Адрес доставки</label>
                <div class="col-sm-10">
                    <input
                    type="text"
                    placeholder="Введите адрес доставки"
                    class="form-control"
                    v-model="workorder.address"
                    />                
                </div>
            </div>
          </div>
          <div class="workorder_fueltable_container">
            <table class="table workorder_fueltable" >
                <thead>
                    <th>НП</th>
                    <th>Объем</th>
                    <th><button @click="addNewFuelItem">+</button></th>
                </thead>
                <tr v-for="(item, i) in workorder.items" :key="i" 
                    :style="item.status=='deleted' ? 'display:none' : ''"
                    :class="errors.itemErrNumber==i ? 'workorder_from_errortable':''"
                >
                    <td>
                        <v-select 
                            style="padding: 0 0 0.5rem 0"
                            :options="fuelsOptions" 
                            :reduce="(option) => option.id"
                            :clearable="false"
                            :searchable="false"
                            v-model="item.product_id"
                            :selectable="(option) => !option.removed"

                            v-if="fuelsOptions.length>0"
                        >
                        </v-select>
                    </td>
                    <td>
                        <input type="number" v-model="item.quantity" class="form-control workorder_fuelquantity" size="7"/>
                    </td>
                    <td><button @click="deleteFuelItem(i)">Удалить</button></td>
                </tr>
            </table>
          </div>
        </template>
        <template slot="block">
            <div class="row workorder_from_errortable"  v-if="errorMsg!=''">
                <div class="col">{{ errorMsg }}</div>
            </div>
        </template>
        <template slot="footer">
            <button _type="submit" class="btn btn-success btn-min-width" style="margin-right: 14px;" @click="saveWorkorder">
                <i class="icon-save"></i> Сохранить 
            </button>
            <a href="/workorders" class="btn btn-secondary btn-min-width router-link-active">
                <i class="icon-arrow-left2"></i> Вернуться в раздел </a>
        </template>
        </card>
    </div>
  </div>
</template>

<script>
import ContentHeader from "@/components/ContentHeader.vue";
import card from "@/components/card.vue";

import { mapGetters } from "vuex";
import { WORK_ORDERS_REQUEST, WORKORDER_UPDATE_REQUEST } from "@/store/actions/workorders";
import { STATIONS_2_REQUEST, FUELS_REQUEST } from "@/store/actions/stations";
import { CARDS_REQUEST } from "@/store/actions/cards";

export default {
  name: "WorkordersEdit",
  components: {
    ContentHeader,
    card,
  },
  data() {
    return {
        errors: { stationErr: false, cardErr: false, itemErrNumber: null },
        errorMsg: '',

        workorder: undefined, //this.getEmptyWorkOrder(),
        id: null,

        cardsOptions: [],
        stationsOptions: [],
        fuelsOptions: [],

    };
  },
  computed: {
    ...mapGetters([
      //"getCurrencyName",

      "getWorkOrders",
      "getWorkOrderById",
      "isWorkOrdersLoading",
      //"isWorkOrdersFailed",
      "workOrdersOnceLoaded",

      "stations2OnceLoaded",
      "getStations2",
      "isStations2Loading",

      "fuelsOnceLoaded",
      "isFuelsLoading",
      "getFuels",

      "cardsOnceLoaded",
      "getCards",
      "isCardsLoading"
    ]),
  },  
  methods: {
    getEmptyWorkOrder() {
        console.log('START getEmptyWorkOrder()')
        let emptyItems = [{id: null, product_id: '', quantity: '', status: 'new'}];
        return {
            id: undefined, 
                target_date: new Date(),
                address: '',
                card_id: null,
                holder_name: '',
                items: emptyItems,
                station_id: null,
        }

    },

    setWorkOrder() {
        console.log('START setWorkOrder()')
        this.errorMsg = '';
        if (this.errors)
        {
            this.errors.stationErr = false;
            this.errors.cardErr = false;
            this.errors.itemErrNumber = null;
        }

        let emptyItems = [{id: null, product_id: '', quantity: '', status: 'new'}];
        if (this.id != undefined) {
            console.log(this.id);
            console.log(this.getWorkOrders);
            let workorder = this.getWorkOrderById( this.id );
            
            //let cardID = this.getCardOptionsItem(workorder.card_id, workorder.holder_name);
            let items = [];
            workorder.items.forEach( wItem => {
                items.push({
                    id: wItem.id,
                    product_id: wItem.product_id,
                    quantity: wItem.quantity,
                    status: wItem.status
                });
            })
            if (items.length == 0)
                items = emptyItems
            //console.log(workorder);

            this.workorder = {
                id: workorder.id, 
                target_date: new Date(workorder.target_date),
                address: workorder.address,
                card_id: workorder.card_id,
                holder_name: workorder.holder_name,
                items: items,
                //region_name: workorder.region_name,
                //region_prefix: workorder.region_prefix,
                station_id: workorder.station_id,
                //station_name: workorder.station_name,
            };
            //console.log(this.workorder);
        }
        else {
            this.workorder = this.getEmptyWorkOrder();
        }

        console.log(this.workorder);
        console.log('END setWorkOrder()');
    },

    checkWorkorder() {
        this.errors.stationErr = false;
        this.errors.cardErr = false;
        this.errors.itemErrNumber = null;
        this.errorMsg = '';

        if ( !this.workorder.station_id )
        {
            this.errors.stationErr = true;
            this.errorMsg = 'Выберите объект';
            return false;
        }
        /*
        if ( !this.workorder.card_id )
        {
            this.errors.cardErr = true;
            this.errorMsg = 'Выберите карту / водителя';
            return false;
        }*/
        
        this.workorder.items.forEach( (item, i) => {
            if (this.errors.itemErrNumber == null) {
                if (!item.product_id || !item.quantity || isNaN( parseFloat (item.quantity) ))
                {
                    this.errors.itemErrNumber = i;
                    if (!item.product_id)
                        this.errorMsg = 'Выберите НП';
                    else
                        if (!item.quantity)
                            this.errorMsg = 'Введите объем';
                }
                else  {
                    let value = parseFloat (item.quantity);
                    if (value < 1 || value > 100000)
                    {
                        this.errors.itemErrNumber = i;
                        this.errorMsg = 'Неверно задан объем';
                    }
                }
            }
        });
        if (this.errors.itemErrNumber != null)
            return false;

        return true;
    },

    saveWorkorder() {
        if (!this.checkWorkorder())
            return;

        let wo = {
                //target_date: this.workorder.target_date,
                target_date: this.workorder.target_date.toLocaleString('en-GB', {
                                year: 'numeric',
                                month: '2-digit',
                                day: '2-digit',
                                hour: '2-digit',
                                minute: '2-digit',
                                second: '2-digit',
                            }),
                address: this.workorder.address,
                card_id: this.workorder.card_id,                
                station_id: this.workorder.station_id,
                items: [], // this.workorder.items,
            }
        this.workorder.items.forEach( item => {
            let newItem = {            
                product_id: item.product_id,
                quantity: parseFloat(item.quantity),
                //status: item.status
            }
            if (item.id)
                newItem['id'] = item.id;
            if (item.status != '' && item.status != 'new')
                newItem['status'] = item.status;

            wo.items.push( newItem );
        })
        if (this.id)
            wo["id"] = parseInt(this.id);

        console.log(wo);

        this.$store
        .dispatch(WORKORDER_UPDATE_REQUEST, { method: this.id ? 'PATCH' : 'POST', data: wo })
        .then(() => {
            //alert('save OK!!!');
            //this.$store.dispatch(WORK_ORDERS_REQUEST); 
            this.$router.push("/workorders");
        })
        .catch((err) => {
            //alert(err.response.data.error);
            this.errorMsg = err.response.data.error;
        });
    },

    show_workorders() {
        console.log(this.getWorkOrders);
    },

    getCardOptionsItem(cardId, cardHolderName) {
        let strHolder = cardHolderName ? ' / ' + cardHolderName : '';
        return { label: cardId + strHolder, id: cardId };
    },
    getProductOptionsItem(productId, productName, removed) {
        return { label: productName, id: productId, removed: removed }
    },
    setCardsOptions() {
        if (!this.cardsOnceLoaded)
            return;

        this.cardsOptions = [];
        let cards = this.getCards();
        cards.forEach( card => {
            //let strHolder = card.holder_name ? ' / ' + card.holder_name : '';
            //this.cardsOptions.push({ label: card.id + strHolder, id: card.id });
            this.cardsOptions.push( this.getCardOptionsItem(card.id, card.holder_name) );
        })
    },
    setStationsOptions() {
        if (!this.stations2OnceLoaded)
            return;

        this.stationsOptions = [];
        let stations = this.getStations2;
        stations.forEach( station => {
            if (station.enabled == true && station.wo_enabled == true)
            {
                let prefixStr = station.prefix ? station.prefix + '-' : '';
                this.stationsOptions.push({ label: prefixStr + station.name, id: station.id });
            }
        })
    },
    setFuelsOptions() {
        if (!this.fuelsOnceLoaded)
            return;

        this.fuelsOptions = [];
        let fuels = this.getFuels;
        fuels.forEach( fuel => {
            this.fuelsOptions.push( this.getProductOptionsItem( fuel.id, fuel.name, fuel.removed ) );
        })
    },

    addNewFuelItem() {
        let newItem = {id: null, product_id: '', quantity: '', status: ''};
        this.workorder.items.push( newItem );
    },
    deleteFuelItem( itemIndex ) {
        let item = this.workorder.items[itemIndex];
        if (item.status == "new")
            this.workorder.items.splice(itemIndex,1);
        else
            this.workorder.items[itemIndex].status = "deleted";
    },

  },
  
  mounted() {
    console.log('START created()')
      this.id = this.$route.params.id;
      if (this.id == 'null')
        this.id = undefined;

      if (this.id)
      {
        if (!this.workordersOnceLoaded) {
            this.$store.dispatch(WORK_ORDERS_REQUEST)
                .then( this.setWorkOrder );
        }
        else
            this.setWorkOrder();
      }
      else
        this.setWorkOrder();

      if (!this.stations2OnceLoaded) 
        this.$store.dispatch(STATIONS_2_REQUEST)
            .then( this.setStationsOptions );
      else
        this.setStationsOptions();

      if (!this.cardsOnceLoaded) {
        this.$store.dispatch(CARDS_REQUEST).then( () => {
            this.setCardsOptions();
        });
      } else
        this.setCardsOptions();
        
    if (!this.fuelsOnceLoaded) {
        this.$store.dispatch(FUELS_REQUEST)
        .then( this.setFuelsOptions )
      } else
        this.setFuelsOptions();

    console.log(this.workorder);
    console.log('END created()')

  },
};
</script>

<style>
.workorder_fueltable {
    width: 50%;
    margin-left: auto;
    margin-right: auto;
}
.workorder_fueltable th {
    text-align: center;
}
.workorder_fueltable tr:hover{
    background: #f5f5f5;
}
.workorder_fueltable_container {
    text-align: center;
}
.workorder_fuelquantity {
    text-align: center;
}
#workordereditform .workorder_from_error label {
    color: red;
}

.workorder_from_errortable {
    /*color: red;*/
    background: #FF000011;
}
.workorder_fueltable tr.workorder_from_errortable:hover {
    background: #FF000022;
}
</style>